import React from 'react';
import { ICON } from 'resources/constants';
import { useImage, useConfig, useText } from 'common/hooks';
import { getQuizSummaryContent } from 'utils/challenge';

import {
  Container,
  ImageWrapper,
  ScoreWrapper,
  Score,
  Image,
  TextWrapper,
  Title,
  Text,
  KnowledgeWrapper,
  KnowledgeIcon,
  Button,
} from './elements';

type Props = {
  readonly className?: string;
  readonly score: number;
  readonly totalQuestions: number;
  readonly tag: string;
  readonly onReviewClicked: () => void;
};

function Summary({
  className,
  score,
  totalQuestions,
  tag,
  onReviewClicked,
}: Props): React.ReactElement {
  const { staticUrl } = useConfig();
  const t = useText();

  const { image, textPath } = getQuizSummaryContent(
    staticUrl,
    score,
    totalQuestions
  );

  const [imageUrl] = useImage(image);

  return (
    <Container className={className} allCorrect={score === totalQuestions}>
      <KnowledgeWrapper>
        <KnowledgeIcon color={'#fff'} icon={ICON.school} />
      </KnowledgeWrapper>
      <ImageWrapper>
        <ScoreWrapper>
          <Score>{`${score}/${totalQuestions}`}</Score>
        </ScoreWrapper>
        <Image src={imageUrl} />
      </ImageWrapper>
      <TextWrapper>
        <Title>{t(textPath)}</Title>
        <Text>{t(`challenge.quiz.end_page.use_knowledge.${tag}`)}</Text>
        <Button onClick={onReviewClicked}>
          {t('challenge.quiz.common.review_answers')}
        </Button>
      </TextWrapper>
    </Container>
  );
}

export default Summary;
